<template>
  <BattlesList :id="accountId" :type="accountType" :list-type="valueModel" />
</template>

<script>
import { mapState } from 'vuex';
import valueModel from '@/mixins/valueModel';
import { translate } from '@/mixins/translate';
import BattlesList from '@/views/account/content/battles/BattlesList';

export default {
  name: 'ProfileBattles',
  components: {
    BattlesList,
  },
  mixins: [valueModel, translate('_web_account_battles_list')],
  computed: {
    ...mapState('current', ['accountId', 'accountType']),
    ...mapState('my', { myId: 'accountId' }),
  },
};
</script>
